import classnames from 'classnames';
import Image from 'next/image';
import { BsXLg } from 'react-icons/bs';

type Props = {
  children: React.ReactNode;
  visible: boolean;
  onClose: () => void;
};

const MobileSidebarLayout = ({ children, visible, onClose }: Props) => {
  return (
    <aside
      className={classnames(
        'fixed inset-0 size-full bg-white text-gray-600 transition-all duration-300 ease-in sm:hidden',
        {
          '-z-100 translate-y-full opacity-0': !visible,
          'z-100 translate-y-0 opacity-100': visible,
        }
      )}
    >
      <section className="mx-4 flex items-center justify-between py-2">
        <Image
          src="/logo_square.svg"
          alt="Tabist Logo"
          width={40}
          height={40}
          className="cursor-pointer"
        />
        <button type="button" onClick={onClose}>
          <BsXLg size={18} />
        </button>
      </section>
      <div className="px-4 pt-2">{children}</div>
    </aside>
  );
};

export default MobileSidebarLayout;
